import React, { useState, useEffect } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { BaseFormFields, useBaseForm } from "./BaseFormFields";
import * as api from "../../lib/api";

export function SoftwareUpdateForm({ onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, ticketType, onTypeChange }) {
    const baseForm = useBaseForm("low");
    const [software, setSoftware] = useState([]);
    const [selectedSoftware, setSelectedSoftware] = useState([]);
    const [targetMachine, setTargetMachine] = useState("");

    useEffect(() => {
        loadSoftware();
    }, []);

    const loadSoftware = async () => {
        try {
            const data = await api.getSoftwareCatalog();
            setSoftware(data);
        } catch (error) {
            console.error("Failed to load software:", error);
        }
    };

    const toggleSoftware = (sw) => {
        setSelectedSoftware((prev) => {
            const exists = prev.find((s) => s.software_id === sw.id);
            if (exists) {
                return prev.filter((s) => s.software_id !== sw.id);
            } else {
                return [
                    ...prev,
                    {
                        software_id: sw.id,
                        software_name: sw.name,
                        current_version: "",
                        target_version: sw.version,
                    },
                ];
            }
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const softwareNames = selectedSoftware.map((s) => s.software_name).join(", ");
        onSubmit({
            title: baseForm.title || `Mise à jour logiciel - ${softwareNames}`,
            description: baseForm.description,
            priority: baseForm.priority,
            dynamic_fields: {
                software_items: selectedSoftware,
                target_machine: targetMachine,
            },
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <BaseFormFields
                ticketType={ticketType}
                onTypeChange={onTypeChange}
                {...baseForm}
                onTitleChange={onTitleChange}
                    allowedPriorities={allowedPriorities}
                titlePlaceholder="Ex: Mise à jour Office 365"
                descriptionPlaceholder="Raison de la mise à jour..."
            >
                <div className="form-group">
                    <Label className="form-label">Logiciels à mettre à jour</Label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 border rounded-md p-3">
                        {software.map((sw) => (
                            <label
                                key={sw.id}
                                className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded cursor-pointer"
                            >
                                <Checkbox
                                    checked={selectedSoftware.some((s) => s.software_id === sw.id)}
                                    onCheckedChange={() => toggleSoftware(sw)}
                                    data-testid={`software-${sw.id}`}
                                />
                                <div>
                                    <div className="text-sm font-medium">{sw.name}</div>
                                    <div className="text-xs text-gray-500">vers v{sw.version}</div>
                                </div>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="form-group">
                    <Label className="form-label">Machine cible</Label>
                    <Input
                        value={targetMachine}
                        onChange={(e) => setTargetMachine(e.target.value)}
                        placeholder="Nom de la machine ou numéro d'inventaire"
                        data-testid="target-machine"
                    />
                </div>
            </BaseFormFields>

            <div className="mt-6 flex justify-end">
                <Button type="submit" disabled={!baseForm.title || submitting} data-testid="submit-ticket">
                    {submitting ? "Création..." : "Soumettre le ticket"}
                </Button>
            </div>
        </form>
    );
}
